import Crud from '../views/Prioridade/Crud'
import Entity from '../views/Prioridade/Add'
import View from '../views/Prioridade/View'

let routes = {
    path: '/prioridades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/prioridades/add',
            name: 'NewPrioridade',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Prioridade',
                breadcrumb: [
                    {
                        text: 'Prioridades',
                        active: false,
                        to: '/prioridades',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/prioridades/edit/:id?',
            name: 'EditPrioridade',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Prioridade',
                breadcrumb: [
                    {
                        text: 'Prioridades',
                        active: false,
                        to: '/prioridades',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/prioridades/view/:id?',
            name: 'ViewPrioridade',
            component: View,
            meta: {
                pageTitle: 'Visualizar Prioridade',
                breadcrumb: [
                    {
                        text: 'Prioridades',
                        active: false,
                        to: '/prioridades',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/prioridades',
            name: 'list-prioridades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Prioridades',
                breadcrumb: [
                    {
                        text: 'Prioridades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
